"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStablecoinDealingAvailable = exports.isVaultSetupOffered = void 0;
/** Shared stablecoin dealing gate (API + web): both sides run the same check on the same data. */
const mystake_common_sdk_1 = require("@redbelly-tokeniser/mystake-common-sdk");
const linkedClassIssue_1 = require("./linkedClassIssue");
/** Whether a fund may deploy an ERC-7540 vault: both flags on and the registry is a fund. */
const isVaultSetupOffered = ({ features, registryType }) => features?.[mystake_common_sdk_1.FeatureIds.TOKEN_CONFIGURATION_ENABLED] === true &&
    features?.[mystake_common_sdk_1.FeatureIds.ERC7540_VAULT] === true &&
    (0, mystake_common_sdk_1.isCapabilityAvailable)(mystake_common_sdk_1.FeatureIds.ERC7540_VAULT, registryType);
exports.isVaultSetupOffered = isVaultSetupOffered;
/**
 * Whether an investor may deal in stablecoin on this class: setup offered, registry live, token
 * deployed, and a vault deployed for an enabled stablecoin.
 */
const isStablecoinDealingAvailable = (inputs) => {
    const enabled = new Set(inputs.enabledStablecoins.map((address) => address.toLowerCase()));
    return ((0, exports.isVaultSetupOffered)(inputs) &&
        inputs.registryLive === true &&
        (0, linkedClassIssue_1.isErc3643LinkedShareClass)(inputs.shareClass) &&
        Boolean(inputs.shareClass?.rwaVaults?.some((vault) => vault.vaultAddress?.trim() && enabled.has(vault.assetAddress?.toLowerCase() ?? ""))));
};
exports.isStablecoinDealingAvailable = isStablecoinDealingAvailable;
//# sourceMappingURL=stablecoinDealing.js.map